import React, {PureComponent} from 'react';
import {FastField, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormRow from '../FormRow';
import CommonFields from './CommonFields';
import Error from '../../../Error';

class Date1Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;
        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <FormRow name={`${name}.min`} label={messages.surveys.form.label.min} size={3}>
                    <FastField id={`${name}.min`} name={`${name}.min`} type="date"
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.min`) && (get(form.touched, `${name}.min`) || get(form.touched, `${name}.max`))})} />
                    <ErrorMessage name={`${name}.min`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <FormRow name={`${name}.max`} label={messages.surveys.form.label.max} size={3}>
                    <FastField id={`${name}.max`} name={`${name}.max`} type="date"
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.max`) && (get(form.touched, `${name}.max`) || get(form.touched, `${name}.max`))})} />
                    <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
            </>
        );
    }
}

export default Date1Type;
